import {USERINFO_SELECT} from 'src/redux/actions/actionTypes';

let userInfoData = [];

export const mainProfilesReducer = (state = userInfoData, action) => {
  switch (action.type) {

    case USERINFO_SELECT:
      userInfoData.splice(0, userInfoData.length);
      if (action.payload.data === undefined) {
        return state;
      } else if (action.payload.data.resultCode === 'S0000') {
        // console.log("beta",action.payload.data.res)
        userInfoData.push(action.payload.data.res);
        return userInfoData;
      }
      return userInfoData;
    default:
      return state;
  }
};
  
  